import { useState } from "react";
import Flag from "react-flagkit";
import { useTranslation } from "react-i18next";
import { IoEarthSharp } from "react-icons/io5";
import OutsideClickHandler from "react-outside-click-handler";

import useGetColours from "../helpers/getColours";

const lngs = {
  en: { nativeName: "English", flag: "GB" },
  de: { nativeName: "Deutsch", flag: "DE" },
  fr: { nativeName: "Français", flag: "FR" },
};

function LanguageSelector() {
  const { i18n } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const { highlightColour, onboardingHighlightColour } = useGetColours();
  // Use highlightColour when authenticated, fall back to onboardingHighlightColour for login/onboarding screens
  const iconColour = highlightColour || onboardingHighlightColour;
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setShowMenu(false);
      }}
    >
      <div className="relative inline-block text-left md:mt-0 ">
        <div className="flex items-center">
          <button
            onClick={() => setShowMenu(!showMenu)}
            type="button"
            className="inline-flex justify-center w-full px-2 py-2 font-medium focus:outline-none"
            id="language-button"
            aria-expanded="true"
            aria-haspopup="true"
          >
            <IoEarthSharp size={22} style={{ color: iconColour }} />
            <svg
              className="w-6 h-6 ml-1 mr-1 text-old-sentric-light-gray"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
        {showMenu && (
          <div
            className="absolute right-0 mt-2 overflow-hidden origin-top-right bg-white rounded-md shadow-lg w-44 h-fit ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="language-button"
            tabIndex="-1"
          >
            <div>
              <div role="menuitem" tabIndex="-1">
                {Object.keys(lngs).map(lng => (
                  <button
                    className={`${
                      lngs[lng].nativeName === "None" ? "" : "border-b"
                    } hover:bg-gray-50 ${
                      i18n.resolvedLanguage === lng
                        ? "bg-gray-200 font-semibold"
                        : ""
                    } text-gray-700 flex items-start gap-2 w-full text-left px-4 py-2 text-sm`}
                    type="submit"
                    role="menuitem"
                    key={lng}
                    onClick={() => i18n.changeLanguage(lng)}
                    disabled={i18n.resolvedLanguage === lng}
                  >
                    {lngs[lng].nativeName === "None" ? (
                      <img
                        src={lngs[lng].flag}
                        alt={`${lngs[lng].nativeName} flag.`}
                        className="w-5"
                      />
                    ) : (
                      <Flag country={lngs[lng].flag} />
                    )}
                    {" "}
                    {lngs[lng].nativeName}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
}

export default LanguageSelector;
